import React from 'react';
import useRevokeUserAccessOnSurface from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/hooks/use-revoke-user-access-on-surface';
import useDeleteUserInvitationOnSurface from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/hooks/use-delete-user-invitation-on-surface';
import { SubSurfaceNode } from 'graphql/types';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import apolloClient from 'services/apollo-client';
import { fetchUsersWithAccessToSurfaceQuery } from 'graphql/user/queries/fetch-users-with-access-to-surface';
import { set } from 'lodash/fp';

interface UseRevokeAction {
  isLoading: boolean;
  showConfirmationMessage: boolean;
  cancelRevoking: Function;
  onRevokeConfirm: Function;
  revokeAccess: (input: { user: string; invitation: string }) => Function;
}

export default function useRevokeAction(
  sharedRootSurface: SubSurfaceNode,
): UseRevokeAction {
  const [isLoading, setLoading] = React.useState(false);
  const { id: surface } = useCurrentSurface() || {};
  const [revokeFor, setRevokeFor] = React.useState<{
    invitation?: any;
    user?: any;
  }>();

  const revokeUserAccessOnSurface = useRevokeUserAccessOnSurface();

  const deleteUserInvitationOnSurface = useDeleteUserInvitationOnSurface();

  function revokeAccess({ user, invitation }) {
    return function () {
      // Check if it is deep indirect share

      /*if (sharedRootSurface) {
        return setRevokeFor({ user, invitation });
      }*/

      return confirmRevoke({ user, invitation });
    };
  }

  function revokeAccessOptimisticUpdate({ user, invitation }) {
    const email = user?.email ?? invitation?.email;

    if (email) {
      const userAccessList = apolloClient.readQuery({
        query: fetchUsersWithAccessToSurfaceQuery,
        variables: { surface },
      });

      const newUserAccessList = userAccessList.fetchUsersWithAccessToSurface.nodes.filter(
        (data) =>
          data?.user?.email !== email || data?.invitation?.email !== email,
      );

      apolloClient.writeQuery({
        query: fetchUsersWithAccessToSurfaceQuery,
        variables: { surface },
        data: set(
          'fetchUsersWithAccessToSurface.nodes',
          newUserAccessList,
          userAccessList,
        ),
      });
    }
  }

  async function confirmRevoke(input) {
    if (input?.user || input?.invitation) {
      const { user, invitation } = input;

      revokeAccessOptimisticUpdate(input);

      setLoading(true);

      if (invitation) {
        await deleteUserInvitationOnSurface(invitation);
      }

      if (user?.id) {
        // If it is sub surface of shared show message that recursivly will be revoked access
        await revokeUserAccessOnSurface(user);
      }

      setLoading(false);
      setRevokeFor(undefined);
    }
  }

  function cancelRevoking() {
    setRevokeFor(undefined);
  }

  function onRevokeConfirm() {
    confirmRevoke(revokeFor);
  }

  return {
    isLoading,
    cancelRevoking,
    onRevokeConfirm,
    showConfirmationMessage: revokeFor?.invitation && revokeFor?.user,
    revokeAccess,
  };
}
